export default "__VITE_ASSET__BGWFeXk0__"